export enum MyAccountEvents {
  ON_LOGIN_SUCCESS = 'on_login_success',
  ON_SIGNUP_SUCCESS = 'on_signup_success',
  ON_STORE_ACCESS_TOKEN = 'on_store_access_token',
}
